<ng-container *ngIf="organization$ | async as organization">
  <div class="row mb-3">
    <div class="col-12 col-lg-10 order-2 order-lg-1">
      <h3 *ngIf="!organization.isSupervisor">Pågående aktiviteter</h3>
      <h3 *ngIf="organization.isSupervisor">Aktivitetsmallar</h3>
    </div>

    <div class="col-12 col-lg-2 order-1 order-lg-2 mb-4 mb-2 mb-lg-0" *ngIf="showButtons">
      <button
        class="btn btn-primary w-100"
        [routerLink]="['/organization', organization.id, 'activities', 'create']"
        [queryParams]="{ type: organization.isSupervisor ? 'template' : '' }">
        <span class="material-icons">add</span>
        <span *ngIf="!organization.isSupervisor">Ny aktivitet</span>
        <span *ngIf="organization.isSupervisor">Ny aktivitetsmall</span>
      </button>
    </div>
  </div>
  <div class="text-muted fst-italic" *ngIf="isLoadingActivities$ | async">
    <span class="align-middle" *ngIf="!organization.isSupervisor">Hämtar aktiviteter...</span>
    <span class="align-middle" *ngIf="organization.isSupervisor">Hämtar mallar & aktiviteter...</span>
  </div>
  <div class="row d-flex mb-3" *ngIf="(isLoadingActivities$ | async) === false">
    <ng-container *ngIf="currentActivities$ | async as currentActivities">
      <span class="text-muted fst-italic" *ngIf="currentActivities.length === 0 && !organization.isSupervisor"
        >Organisationen har inga pågående aktiviteter</span
      >
      <span class="text-muted fst-italic" *ngIf="currentActivities.length === 0 && organization.isSupervisor"
        >Organisationen har inga aktiva aktivitetsmallar</span
      >

      <div class="col-sm-6 col-lg-4 mb-3 align-self-stretch" *ngFor="let activity of currentActivities">
        <app-activity-item-card [organization]="organization" [activity]="activity"></app-activity-item-card>
      </div>
    </ng-container>
  </div>
</ng-container>
